/**
 * User: nir
 * Date: 30/09/2016
 * Time: 13:26
 */

if (window.jQuery) {
    window.jQuery(function ($) {

        var selector = '[data-role=carousel]',
            elements = $(selector);


        elements.each(function (i, e) {
            var element = $(e),
                children = element.children(),
                count = children.length,
                buttonLeft=$($(element.parent()).find('.button-left')),
                buttonRight=$($(element.parent()).find('.button-right'));
            if (count < 2) return;

            var delaySeconds = element.data('delay') || 7,
                currentIndex = 0,
                indicatorSelector = element.data('indicator') || null,
                indicator = indicatorSelector ? $(indicatorSelector) : null,
                indicatorChildren = indicator ? indicator.children() : null,
                interval = null;


            function next() {
                setCurrent((currentIndex + 1) % count);
            }

            function previous() {
                setCurrent((currentIndex - 1 + count) % count);
            }

            function swipeNext() {
                if (currentIndex < count - 1) {
                    next();
                    restart();
                }
            }

            function swipePrevious() {
                if (interval || currentIndex > 0) {
                    previous();
                    restart();
                }
            }

            function setCurrent(index) {
                currentIndex = index;
                element.css({transform: 'translateX(' + (currentIndex * -100) + '%)'});

                if (indicatorChildren) {
                    indicatorChildren.toggleClass('active', false).eq(index).toggleClass('active', true);
                }
            }

            function change(ev) {
                if (ev && ev.preventDefault) ev.preventDefault();

                var item = $(this),
                    index = item ? item.index(): 0;

                setCurrent(index);
            }

            function start() {
                clear();
                if (count > 1 && delaySeconds>0) interval = setInterval(next, delaySeconds * 1000);
            }

            function stop() {
                clear();
            }

            function restart() {
                stop();
                start();
            }

            function clear() {
                if (interval) {
                    clearInterval(interval);
                    interval = null;
                }
            }
            function nextButton(){
                if (count>currentIndex+1)
                {
                    if (buttonLeft.css('display')==='none')
                        buttonLeft.css('display','block');
                    setCurrent(currentIndex+1);
                }
                else if ( count === currentIndex+1 ){
                  setCurrent( 0 )
                }
            }
            function previousButton(){
                if (0<=currentIndex-1)
                {
                    if (buttonRight.css('display')==='none')
                        buttonRight.css('display','block');
                    setCurrent(currentIndex-1);
                }
                else {
                  setCurrent( count - 1 )
                }

            }
            function checkButtonDisplay(button,indexCondition){
                if (indexCondition && button.css('display')!=='none')
                {
                    button.css('display','none');
                }
            }
            if (buttonLeft!=null){
                //delaySeconds=0;
                buttonLeft.click(previousButton);
            }
            if (buttonRight!=null){
                buttonRight.click(nextButton);
            }

            setCurrent(0);
            start();

            if (indicator) {
                indicator.on('click', 'li', change);
            }

            element
                .on('mouseover touchstart', stop)
                .on('mouseout touchend', start)
                .on('swipe-right', swipePrevious)
                .on('swipe-left', swipeNext);



        });
    });
}